/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


document.addEventListener('product:added', function(event) {
  pintrk('track', 'addtocart');
});



/* Replace Old Word to New Word */

const replaceWord = [
  { oldword: "oldword1", newword: "newword1" },
  { oldword: "oldword2", newword: "newword2" },
  { oldword: "oldword3", newword: "newword3" }
];

// Function to add links to the description
function replaceToNewword() {
  // Get all product descriptions (adjust selector as necessary)
  const descriptions = document.querySelectorAll(".card__collapsible-content");

  descriptions.forEach(description => {
    let descriptionHTML = description.innerHTML;

    // Regex to match <img> tags
    const imgTagRegex = /<img[^>]*alt="[^"]*"[^>]*>/gi;

    // Temporarily store <img> tags to avoid altering them
    const imgTags = [];
    descriptionHTML = descriptionHTML.replace(imgTagRegex, match => {
      imgTags.push(match);
      return `<IMG_PLACEHOLDER_${imgTags.length - 1}>`;
    });
    
    // Loop through each keyword and replace it with the link
    replaceWord.forEach(item => {
      const regex = new RegExp(`\\b${item.oldword}\\b`, 'gi'); // Match whole words, ignore case
      const replacement = `${item.newword}`;
      descriptionHTML = descriptionHTML.replace(regex, replacement);
    });

    // Restore <img> tags
    imgTags.forEach((imgTag, index) => {
      descriptionHTML = descriptionHTML.replace(`<IMG_PLACEHOLDER_${index}>`, imgTag);
    });
    
    // Replace the original description with the updated version
    description.innerHTML = descriptionHTML;
  });
}

// Run the function after the page has fully loaded
document.addEventListener("DOMContentLoaded", replaceToNewword);






/* Add Automated Links to specific words */

// Define an array of keywords and their corresponding links
const keywordLinks = [
  { keyword: "ExampleWord1", link: "https://google.com" },
  { keyword: "ExampleWord2", link: "https://example2.com" },
  { keyword: "ExampleWord3", link: "https://example3.com" }
];

// Function to add links to the description
function addLinksToDescription() {
  // Get all product descriptions (adjust selector as necessary)
  const descriptions = document.querySelectorAll(".card__collapsible-content");

  descriptions.forEach(description => {
    let descriptionHTML = description.innerHTML;

    // Regex to match <img> tags
    const imgTagRegex = /<img[^>]*alt="[^"]*"[^>]*>/gi;

    // Temporarily store <img> tags to avoid altering them
    const imgTags = [];
    descriptionHTML = descriptionHTML.replace(imgTagRegex, match => {
      imgTags.push(match);
      return `<IMG_PLACEHOLDER_${imgTags.length - 1}>`;
    });
    
    // Loop through each keyword and replace it with the link
    keywordLinks.forEach(item => {
      const regex = new RegExp(`\\b${item.keyword}\\b`, 'gi'); // Match whole words, ignore case
      const replacement = `<a href="${item.link}" class="custom-link" target="_blank">${item.keyword}</a>`;
      descriptionHTML = descriptionHTML.replace(regex, replacement);
    });

    // Restore <img> tags
    imgTags.forEach((imgTag, index) => {
      descriptionHTML = descriptionHTML.replace(`<IMG_PLACEHOLDER_${index}>`, imgTag);
    });
    
    // Replace the original description with the updated version
    description.innerHTML = descriptionHTML;
  });
}

// Run the function after the page has fully loaded
document.addEventListener("DOMContentLoaded", addLinksToDescription);

// Add/Change link CSS style to class="custom-link"








